import { Form, Input } from 'sections/Form';

import { useSignupForm } from './SignupForm.hooks';

export type UserData = {
  username: string;
  password: string;
};

export function SignupForm(): React.ReactElement {
  const { handleSubmit, register, error, onSubmit } = useSignupForm();

  const inputs: Input[] = [
    {
      name: 'email',
      label: 'email:',
    },
    {
      name: 'password',
      label: 'password:',
      type: 'password',
    },
    {
      name: 'name',
      label: 'name:',
    },
    {
      name: 'family_name',
      label: 'Family name:',
    },
  ];

  return (
    <Form
      onSubmit={handleSubmit(onSubmit)}
      buttonLabel="Sign Up"
      error={error}
      inputs={inputs}
      register={register}
      type="signup"
    />
  );
}
